module.exports = __webpack_public_path__ + "img/RBS04_7_loading.002cb43c.jpg";